import formatSection from './formatSection';
import themeEditor from './themeEditor';

export default () => {
  formatSection();
  themeEditor();
};